<template>
  <v-row class="pt-2" align="center">
    <v-col cols="4" class="text-center">
      <team
        :logoexists="event.AwayTeamLogoExists ? true : false"
        :logo="
          event.AwayTeamMasterTeamID
            ? event.AwayTeamMasterTeamID
            : event.AwayTeamID
        "
        :show-schedule-link="event.ShowSeasonSchedule ? true : false"
        :name="event.AwayTeamName"
        :league-slug="event.ScheduleTextID"
        :team-slug="event.AwayTeamTextID"
      />
    </v-col>
    <v-col cols="4">
      <score
        :event="event"
        v-if="
          event.Live &&
          event.StatusAwayScore !== null &&
          event.StatusHomeScore !== null
        "
      />
      <!--<score :event="event" v-if="true" />-->
      <time-display :event="event" v-else />
    </v-col>
    <v-col cols="4" class="text-center">
      <team
        :event="event"
        :logoexists="event.HomeTeamLogoExists ? true : false"
        :logo="
            event.HomeTeamMasterTeamID
            ? event.HomeTeamMasterTeamID
            : event.HomeTeamID
        "
        :show-schedule-link="event.ShowSeasonSchedule ? true : false"
        :name="event.HomeTeamName"
        :league-slug="event.ScheduleTextID"
        :team-slug="event.HomeTeamTextID"
      />
    </v-col>
  </v-row>
</template>

<script>
import Team from "./Teams/Team";
import Score from "./Teams/Score";
import TimeDisplay from "./Shared/TimeDisplay";

export default {
  name: "Teams",
  components: {
    Team,
    Score,
    TimeDisplay
  },
  props: {
    event: Object,
  },
};
</script>